type IconProps = {
  name: string;
  size?: "sm" | "md" | "lg";
  className?: string;
};

const iconSizes = {
  sm: "1rem",
  md: "1.125rem",
  lg: "1.25rem",
};

export default function Icon({ name, size = "lg", className = "" }: IconProps) {
  return (
    <i
      className={`fas fa-${name} ${className}`}
      aria-hidden="true"
      style={{
        fontSize: iconSizes[size],
        fontWeight: 900,
        lineHeight: "100%",
        letterSpacing: size === "lg" ? "0%" : undefined,
      }}
    />
  );
}

